module.exports = __webpack_public_path__ + "static/media/LED.e712e2e2.png";